
<!-- Any tag modification will change how froala data is saved. See saveWithHtml method -->
<!-- eslint-disable vue/no-v-html -->
<div class="froala-root" v-html="workingContent"></div>
